import { render, staticRenderFns } from "./Arguments2.vue?vue&type=template&id=491be230&"
import script from "./Arguments2.vue?vue&type=script&lang=js&"
export * from "./Arguments2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports